var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BackendService } from './backend.service';
import { StatisticService } from './statistic.service';
import { UserService } from './user.service';
import { LanguageService } from './language.service';
import { TranslateService } from '@ngx-translate/core';
export var Unit;
(function (Unit) {
    Unit["Count"] = "count";
    Unit["Days"] = "days";
})(Unit || (Unit = {}));
// Achievement keyword translations - based on all achievement names and exercise keywords
var ACHIEVEMENT_KEYWORDS = {
    // Achievement names from i18n files
    Holiday: { de: 'Holiday', en: 'Holiday' },
    Rookie: { de: 'Rookie', en: 'Rookie' },
    Frischmacher: { de: 'Frischmacher', en: 'Freshmaker' },
    Fokussierer: { de: 'Fokussierer', en: 'Focuser' },
    Ausgleicher: { de: 'Ausgleicher', en: 'Relaxer' },
    Potpourri: { de: 'Potpourri', en: 'Potpourri' },
    Meilenstein: { de: 'Meilenstein', en: 'Milestone' },
    Tausendsassa: { de: 'Tausendsassa', en: 'Jack of all Trades' },
    Sehkraft: { de: 'Sehkraft', en: 'Eyesight' },
    Achtsamkeit: { de: 'Achtsamkeit', en: 'Mindfulness' },
    Favorit: { de: 'Favorit', en: 'Favorite' },
    EarlyBird: { de: 'Early Bird', en: 'Early Bird' },
    'Early Bird': { de: 'Early Bird', en: 'Early Bird' },
    NackenChampion: { de: 'Nacken-Champion', en: 'Neck Champion' },
    'Nacken-Champion': { de: 'Nacken-Champion', en: 'Neck Champion' },
    RückenChampion: { de: 'Rücken-Champion', en: 'Back Champion' },
    'Rücken-Champion': { de: 'Rücken-Champion', en: 'Back Champion' },
    BeineChampion: { de: 'Beine-Champion', en: 'Legs Champion' },
    'Beine-Champion': { de: 'Beine-Champion', en: 'Legs Champion' },
    B2ActionHero: { de: 'B2Action Hero', en: 'B2Action Hero' },
    'B2Action Hero': { de: 'B2Action Hero', en: 'B2Action Hero' },
    IronWoman: { de: 'Iron(Wo)man', en: 'Iron(Wo)man' },
    '#1': { de: '#1', en: 'First Place' },
    Nikolausi: { de: 'Nikolausi', en: 'Santa Claus' },
    Weltfrauentag: { de: 'Weltfrauentag', en: "Int. Women's Day" },
    'Champions League': { de: 'Champions League', en: 'Champions League' },
    // Exercise title keywords for achievement detection
    // Note: The primary English translation is used for basic matching,
    // but additional variations are checked in exerciseContainsTitel() for robustness
    Nacken: { de: 'Nacken', en: 'neck' },
    Schulter: { de: 'Schulter', en: 'shoulder' },
    Schultern: { de: 'Schultern', en: 'shoulder' },
    Rücken: { de: 'Rücken', en: 'back' },
    Oberkörper: { de: 'Oberkörper', en: 'upper body' },
    Wirbelsäule: { de: 'Wirbelsäule', en: 'spine' },
    Becken: { de: 'Becken', en: 'pelvis' },
    Halswirbelsäule: { de: 'Halswirbelsäule', en: 'cervical spine' },
    Beine: { de: 'Beine', en: 'leg' },
    Bein: { de: 'Bein', en: 'leg' },
    Hüftbeuger: { de: 'Hüftbeuger', en: 'hip flexor' },
    Waden: { de: 'Waden', en: 'calves' },
    Oberschenkel: { de: 'Oberschenkel', en: 'thigh' },
};
var AchievementService = (function () {
    function AchievementService(backendService, stats, userService, languageService, translateService) {
        this.backendService = backendService;
        this.stats = stats;
        this.userService = userService;
        this.languageService = languageService;
        this.translateService = translateService;
    }
    /**
     * Creates initial achievements for a user.
     * @returns A promise that resolves when the operation completes.
     */
    AchievementService.prototype.createInitialAchievementsForUser = function () {
        return this.backendService.post("achievement/initial", {});
    };
    /**
     * Creates a single achievement for a user with specific data.
     * @param achievementName - The name of the achievement.
     * @param data - Data associated with the achievement.
     * @returns A promise that resolves when the operation completes.
     */
    AchievementService.prototype.createSingleAchievementsForUser = function (achievementName, data) {
        return this.backendService.post("achievement/" + achievementName + "/create", data);
    };
    /**
     * Retrieves all achievements for a user.
     * @returns A promise that resolves with an array of Achievement objects.
     */
    AchievementService.prototype.getAllAchievementsForUser = function () {
        return this.backendService.get("achievement");
    };
    /**
     * Retrieves all achievements for a specific user ID.
     * @param userId - The ID of the user.
     * @returns A promise that resolves with an array of Achievement objects.
     */
    AchievementService.prototype.getAllAchievementsForUserId = function (userId) {
        return this.backendService.get("achievement/user/" + userId);
    };
    /**
     * Retrieves achievements for a user to display on a leaderboard.
     * @param userId - The ID of the user.
     * @returns A promise that resolves with an array of Achievement objects.
     */
    AchievementService.prototype.getAchievementsForLeaderboard = function (userId) {
        return this.backendService.get("achievement/top/" + userId);
    };
    /**
     * Retrieves a single achievement by its name.
     * @param achievementName - The name of the achievement.
     * @returns A promise that resolves with the Achievement object.
     */
    AchievementService.prototype.getSingleAchievement = function (achievementName) {
        return this.backendService.get("achievement/" + achievementName);
    };
    /**
     * Updates an achievement for a user identified by name and user ID.
     * @param achievementName - The name of the achievement.
     * @param userId - (Optional) The ID of the user. Defaults to '0' if not provided.
     * @returns A promise that resolves with the updated achievement data.
     * @returns empty object if the achievement limit is activated reached.
     */
    AchievementService.prototype.updateAchievementForUser = function (achievementName, userId) {
        if (userId === void 0) { userId = '0'; }
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.checkAchievementLimit(achievementName)];
                    case 1:
                        _a = (_b.sent());
                        if (!_a) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.isLimitAcivated()];
                    case 2:
                        _a = (_b.sent());
                        _b.label = 3;
                    case 3:
                        if (_a) {
                            console.log(achievementName + " limit reached for today");
                            return [2 /*return*/, {}];
                        }
                        return [2 /*return*/, this.backendService.put("achievement/" + achievementName + "/user/" + userId)];
                }
            });
        });
    };
    /**
     * Checks only the B2Action Hero achievement - useful for daily checks
     * This method should be called:
     * 1. On app startup/login
     * 2. After completing the 4th exercise of the day
     * 3. At midnight (if the app is running)
     * This ensures the achievement is awarded on the 5th day without requiring a 6th day exercise
     * @returns A promise that resolves with the unlocked achievement or empty object
     */
    AchievementService.prototype.checkB2ActionHeroAchievement = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userAchievementData, userStats, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 7]);
                        return [4 /*yield*/, this.getAllAchievementsForUser()];
                    case 1:
                        userAchievementData = _a.sent();
                        return [4 /*yield*/, this.stats.getMyRealStatistic()];
                    case 2:
                        userStats = _a.sent();
                        return [4 /*yield*/, this.checkB2ActionHero(userStats, userAchievementData)];
                    case 3:
                        if (!_a.sent()) return [3 /*break*/, 5];
                        console.log('   🎉 B2Action Hero achievement unlocked!');
                        return [4 /*yield*/, this.updateAchievementForUser('B2Action Hero')];
                    case 4: return [2 /*return*/, _a.sent()];
                    case 5: return [2 /*return*/, {}];
                    case 6:
                        error_1 = _a.sent();
                        console.error('Error checking B2Action Hero achievement:', error_1);
                        return [2 /*return*/, {}];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Processes achievement data based on a program and exercise size for a user.
     * Runs through multiple conditions to check if new achievments got unlocked
     * @param program - The Program object.
     * @param allExerciseSize - Total exercises size.
     * @returns A promise that resolves with an array of unlocked Achievement objects.
     */
    AchievementService.prototype.processAchievementData = function (program, allExerciseSize, finishedFrischmacher, currentExerciseIndex) {
        return __awaiter(this, void 0, void 0, function () {
            var unlockedAchievements, userAchievementData, userStats, _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            return __generator(this, function (_o) {
                switch (_o.label) {
                    case 0:
                        unlockedAchievements = [];
                        return [4 /*yield*/, this.getAllAchievementsForUser()];
                    case 1:
                        userAchievementData = _o.sent();
                        return [4 /*yield*/, this.stats.getMyRealStatistic()];
                    case 2:
                        userStats = _o.sent();
                        _b = (_a = unlockedAchievements).concat;
                        return [4 /*yield*/, this.processDateAchievements()];
                    case 3:
                        unlockedAchievements = _b.apply(_a, [_o.sent()]);
                        _d = (_c = unlockedAchievements).concat;
                        return [4 /*yield*/, this.processExerciseCountAchievements(userStats, userAchievementData)];
                    case 4:
                        unlockedAchievements = _d.apply(_c, [_o.sent()]);
                        _f = (_e = unlockedAchievements).concat;
                        return [4 /*yield*/, this.processChampionAchievements(program, currentExerciseIndex)];
                    case 5:
                        unlockedAchievements = _f.apply(_e, [_o.sent()]);
                        _h = (_g = unlockedAchievements).concat;
                        return [4 /*yield*/, this.processModuleAchievement(program, userAchievementData, finishedFrischmacher)];
                    case 6:
                        unlockedAchievements = _h.apply(_g, [_o.sent()]);
                        _k = (_j = unlockedAchievements).concat;
                        return [4 /*yield*/, this.processSpecialAchievement(program, allExerciseSize, userStats)];
                    case 7:
                        unlockedAchievements = _k.apply(_j, [_o.sent()]);
                        _m = (_l = unlockedAchievements).concat;
                        return [4 /*yield*/, this.processCategoryAchievement(program, userStats, userAchievementData, currentExerciseIndex)];
                    case 8:
                        unlockedAchievements = _m.apply(_l, [_o.sent()]);
                        return [2 /*return*/, unlockedAchievements];
                }
            });
        });
    };
    // Private methods for achievement processing and checks
    /**
     * Processes achievements related to specific dates (e.g. nicolaus day).
     * @returns A promise that resolves with an array of unlocked Achievement objects.
     * @private
     */
    AchievementService.prototype.processDateAchievements = function () {
        return __awaiter(this, void 0, void 0, function () {
            var unlockedAchievements, _a, _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        unlockedAchievements = [];
                        if (!this.isNicolausDay()) return [3 /*break*/, 2];
                        _b = (_a = unlockedAchievements).push;
                        return [4 /*yield*/, this.updateAchievementForUser('Nikolausi')];
                    case 1:
                        _b.apply(_a, [_g.sent()]);
                        _g.label = 2;
                    case 2:
                        if (!this.isBefore0930()) return [3 /*break*/, 4];
                        _d = (_c = unlockedAchievements).push;
                        return [4 /*yield*/, this.updateAchievementForUser('Early Bird')];
                    case 3:
                        _d.apply(_c, [_g.sent()]);
                        _g.label = 4;
                    case 4:
                        if (!this.isInternationalWomensDay()) return [3 /*break*/, 6];
                        _f = (_e = unlockedAchievements).push;
                        return [4 /*yield*/, this.updateAchievementForUser('Weltfrauentag')];
                    case 5:
                        _f.apply(_e, [_g.sent()]);
                        _g.label = 6;
                    case 6: return [2 /*return*/, unlockedAchievements];
                }
            });
        });
    };
    /**
     * Prüft, ob genügend Tage seit der letzten Aktualisierung eines Erfolgs vergangen sind
     * @param name - Name des Erfolgs
     * @param achievements - Array von Erfolgen
     * @param requiredDays - Anzahl der erforderlichen Tage seit der letzten Aktualisierung
     * @returns Boolean, der angibt, ob genügend Tage vergangen sind
     */
    AchievementService.prototype.checkAchievementCooldownDays = function (name, achievements, requiredDays) {
        var matchingAchievement = achievements.find(function (achievement) { return achievement.name === name; });
        if (!matchingAchievement || matchingAchievement.updatedAt.length === 0) {
            // Kein Erfolg mit diesem Namen gefunden oder noch nie aktualisiert
            return true;
        }
        // Das letzte Aktualisierungsdatum abrufen
        var lastUpdateDate = new Date(matchingAchievement.updatedAt[matchingAchievement.updatedAt.length - 1]);
        var today = new Date();
        // Differenz in Millisekunden berechnen
        var diffTime = Math.abs(today.getTime() - lastUpdateDate.getTime());
        // Differenz in Tagen umwandeln
        var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        console.log("Letzte Aktualisierung von " + name + ": " + lastUpdateDate.toISOString() + ", Vergangene Tage: " + diffDays + ", Erforderlich: " + requiredDays);
        // Prüfen, ob genügend Tage vergangen sind
        return diffDays >= requiredDays;
    };
    /**
     * Verarbeitet Erfolge basierend auf Übungszahlen und Streaks.
     * @param userStats - Benutzerstatistiken.
     * @param userAchievementData - Erfolgsdaten für den Benutzer.
     * @returns Ein Promise, das mit einem Array von freigeschalteten Erfolgen aufgelöst wird.
     * @private
     */
    AchievementService.prototype.processExerciseCountAchievements = function (userStats, userAchievementData) {
        return __awaiter(this, void 0, void 0, function () {
            var unlockedAchievements, hasEnoughDays, rookieAchievement, isAlreadyCompleted, updatedAchievement, heroAchievement, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        unlockedAchievements = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 8, , 9]);
                        return [4 /*yield*/, this.checkExerciseCountDays(userStats, 5)];
                    case 2:
                        hasEnoughDays = _a.sent();
                        if (!hasEnoughDays) return [3 /*break*/, 4];
                        rookieAchievement = userAchievementData.find(function (ach) { return ach.name === 'Rookie'; });
                        isAlreadyCompleted = rookieAchievement && (rookieAchievement.progress === 1 || rookieAchievement.finishedAt);
                        if (!!isAlreadyCompleted) return [3 /*break*/, 4];
                        console.log('Aktualisiere Rookie-Erfolg');
                        return [4 /*yield*/, this.updateAchievementForUser('Rookie')];
                    case 3:
                        updatedAchievement = _a.sent();
                        if (Object.keys(updatedAchievement).length > 0) {
                            unlockedAchievements.push(updatedAchievement);
                        }
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this.checkB2ActionHero(userStats, userAchievementData)];
                    case 5:
                        if (!_a.sent()) return [3 /*break*/, 7];
                        console.log('Aktualisiere B2Action Hero Erfolg für neue 5-Tage-Streak');
                        return [4 /*yield*/, this.updateAchievementForUser('B2Action Hero')];
                    case 6:
                        heroAchievement = _a.sent();
                        if (Object.keys(heroAchievement).length > 0) {
                            unlockedAchievements.push(heroAchievement);
                        }
                        _a.label = 7;
                    case 7: return [2 /*return*/, unlockedAchievements];
                    case 8:
                        error_2 = _a.sent();
                        console.error('Fehler bei der Verarbeitung von Übungszählung-Erfolgen:', error_2);
                        return [2 /*return*/, []];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Processes achievements for being a champion in specific exercise categories.
     * @param program - The Program object.
     * @returns A promise that resolves with an array of unlocked Achievement objects.
     * @private
     */
    AchievementService.prototype.processChampionAchievements = function (program, currentExerciseIndex) {
        return __awaiter(this, void 0, void 0, function () {
            var unlockedAchievements, _a, _b, _c, _d, _e, _f, _g, _h;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        unlockedAchievements = [];
                        if (!this.exerciseContainsTitel('Nacken', program, currentExerciseIndex)) return [3 /*break*/, 2];
                        _b = (_a = unlockedAchievements).push;
                        return [4 /*yield*/, this.updateAchievementForUser('Nacken-Champion')];
                    case 1:
                        _b.apply(_a, [_j.sent()]);
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(this.exerciseContainsTitel('Schulter', program, currentExerciseIndex) ||
                            this.exerciseContainsTitel('Schultern', program, currentExerciseIndex))) return [3 /*break*/, 4];
                        // Check both singular and plural forms for shoulders
                        _d = (_c = unlockedAchievements).push;
                        return [4 /*yield*/, this.updateAchievementForUser('Nacken-Champion')];
                    case 3:
                        // Check both singular and plural forms for shoulders
                        _d.apply(_c, [_j.sent()]);
                        _j.label = 4;
                    case 4:
                        if (!this.isBackExercise(program, currentExerciseIndex)) return [3 /*break*/, 6];
                        _f = (_e = unlockedAchievements).push;
                        return [4 /*yield*/, this.updateAchievementForUser('Rücken-Champion')];
                    case 5:
                        _f.apply(_e, [_j.sent()]);
                        _j.label = 6;
                    case 6:
                        if (!this.isLegExercise(program, currentExerciseIndex)) return [3 /*break*/, 8];
                        _h = (_g = unlockedAchievements).push;
                        return [4 /*yield*/, this.updateAchievementForUser('Beine-Champion')];
                    case 7:
                        _h.apply(_g, [_j.sent()]);
                        _j.label = 8;
                    case 8: return [2 /*return*/, unlockedAchievements];
                }
            });
        });
    };
    /**
     * Processes achievements based on modules (e.g. frischmacher) completed within a program.
     * @param program - The Program object.
     * @param userAchievementData - Achievement data for the user.
     * @param finishedFrischmacher - boolean which indicates if the complete frischmacher (2 exercises) are done
     * @returns A promise that resolves with an array of unlocked Achievement objects.
     * @private
     */
    AchievementService.prototype.processModuleAchievement = function (program, userAchievementData, finishedFrischmacher) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var unlockedAchievements, achievementNames, _loop_1, this_1, _i, achievementNames_1, achievementName;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        unlockedAchievements = [];
                        achievementNames = ['Frischmacher', 'Fokussierer', 'Ausgleicher'];
                        _loop_1 = function (achievementName) {
                            var _a, _b, _c, _d, _e, _f;
                            return __generator(this, function (_g) {
                                switch (_g.label) {
                                    case 0:
                                        if (!this_1.randomExersizeContainsTitel(achievementName, program)) return [3 /*break*/, 6];
                                        if (!(achievementName == 'Frischmacher' && finishedFrischmacher)) return [3 /*break*/, 2];
                                        // Use German name for database update
                                        _b = (_a = unlockedAchievements).push;
                                        return [4 /*yield*/, this_1.updateAchievementForUser(achievementName)];
                                    case 1:
                                        // Use German name for database update
                                        _b.apply(_a, [_g.sent()]);
                                        return [3 /*break*/, 4];
                                    case 2:
                                        if (!(achievementName != 'Frischmacher')) return [3 /*break*/, 4];
                                        // Use German name for database update
                                        _d = (_c = unlockedAchievements).push;
                                        return [4 /*yield*/, this_1.updateAchievementForUser(achievementName)];
                                    case 3:
                                        // Use German name for database update
                                        _d.apply(_c, [_g.sent()]);
                                        _g.label = 4;
                                    case 4:
                                        if (!achievementNames.filter(function (t) { return t !== achievementName; }).every(function (t) { return _this.checkAchievementUpdatedToday(t, userAchievementData); })) return [3 /*break*/, 6];
                                        if (!!this_1.checkAchievementUpdatedToday('Potpourri', userAchievementData)) return [3 /*break*/, 6];
                                        _f = (_e = unlockedAchievements).push;
                                        return [4 /*yield*/, this_1.updateAchievementForUser('Potpourri')];
                                    case 5:
                                        _f.apply(_e, [_g.sent()]);
                                        _g.label = 6;
                                    case 6: return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _i = 0, achievementNames_1 = achievementNames;
                        _a.label = 1;
                    case 1:
                        if (!(_i < achievementNames_1.length)) return [3 /*break*/, 4];
                        achievementName = achievementNames_1[_i];
                        return [5 /*yield**/, _loop_1(achievementName)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, unlockedAchievements];
                }
            });
        });
    };
    /**
     * Processes special achievements based on various conditions and statistics.
     * @param program - The Program object.
     * @param allExerciseSize - Total exercises size.
     * @param userStats - User statistics.
     * @returns A promise that resolves with an array of unlocked Achievement objects.
     * @private
     */
    AchievementService.prototype.processSpecialAchievement = function (program, allExerciseSize, userStats) {
        return __awaiter(this, void 0, void 0, function () {
            var unlockedAchievements, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        unlockedAchievements = [];
                        return [4 /*yield*/, this.updateAchievementForUser('Meilenstein')];
                    case 1:
                        _c.sent();
                        if (this.checkIfAllExercisesDone(userStats, allExerciseSize)) {
                            // deploy Iron(Wo)Man with slithly different implementation later (ask birgit)
                            // unlockedAchievements.push(await this.updateAchievementForUser('Iron(Wo)man'));
                        }
                        if (!program._id) return [3 /*break*/, 3];
                        _b = (_a = unlockedAchievements).push;
                        return [4 /*yield*/, this.updateAchievementForUser('Favorit')];
                    case 2:
                        _b.apply(_a, [_c.sent()]);
                        _c.label = 3;
                    case 3: return [2 /*return*/, unlockedAchievements];
                }
            });
        });
    };
    /**
     * Processes achievements related to specific exercise categories.
     * @param program - The Program object.
     * @param userStats - User statistics.
     * @returns A promise that resolves with an array of unlocked Achievement objects.
     * @private
     */
    AchievementService.prototype.processCategoryAchievement = function (program, userStats, userAchievementData, currentExerciseIndex) {
        return __awaiter(this, void 0, void 0, function () {
            var unlockedAchievements, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        unlockedAchievements = [];
                        _b = (_a = unlockedAchievements).concat;
                        return [4 /*yield*/, this.checkExerciseCategoriesDoneOnSameDay(['Entspannung', 'Augen', 'Unten', 'Achtsamkeit'], userStats, userAchievementData, program, currentExerciseIndex)];
                    case 1:
                        unlockedAchievements = _b.apply(_a, [_c.sent()]);
                        return [2 /*return*/, unlockedAchievements];
                }
            });
        });
    };
    // Other utility methods
    /**
     * Checks if the achievement limit is activated for a company.
     * @returns A promise that resolves to a boolean indicating activation status.
     * @private
     */
    AchievementService.prototype.isLimitAcivated = function () {
        return __awaiter(this, void 0, void 0, function () {
            var companyData, isActivated;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userService.getCompany()];
                    case 1:
                        companyData = _a.sent();
                        isActivated = companyData.activateAchievementsLimit ? companyData.activateAchievementsLimit : false;
                        return [2 /*return*/, isActivated];
                }
            });
        });
    };
    AchievementService.prototype.checkAchievementLimit = function (achievementName) {
        return __awaiter(this, void 0, void 0, function () {
            var today, achievement, countToday, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        today = new Date();
                        return [4 /*yield*/, this.getSingleAchievement(achievementName)];
                    case 1:
                        achievement = _a.sent();
                        if (achievement.limit == 0) {
                            return [2 /*return*/, false];
                        }
                        countToday = 0;
                        for (i = 0; i < achievement.updatedAt.length; i++) {
                            if (this.isSameDay(today, new Date(achievement.updatedAt[i]))) {
                                countToday++;
                            }
                        }
                        // Check if today's date occurs frequently enough
                        return [2 /*return*/, countToday >= achievement.limit];
                }
            });
        });
    };
    /**
     * Checks if two dates are on the same day.
     * @param date1 - First date.
     * @param date2 - Second date.
     * @returns Boolean indicating if the dates are the same day.
     * @private
     */
    AchievementService.prototype.isSameDay = function (date1, date2) {
        return (date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate());
    };
    /**
     * Checks if it's before 9:30 AM.
     * @returns Boolean indicating if it's before 9:30 AM.
     * @private
     */
    AchievementService.prototype.isBefore0930 = function () {
        var now = new Date();
        var hours = now.getHours();
        var minutes = now.getMinutes();
        return hours < 9 || (hours === 9 && minutes < 30);
    };
    /**
     * Checks if it's Nicolaus Day (December 6th).
     * @returns Boolean indicating if it's Nicolaus Day.
     * @private
     */
    AchievementService.prototype.isNicolausDay = function () {
        var now = new Date();
        return now.getMonth() === 11 && now.getDate() === 6;
    };
    /**
     * Checks if it's International Women's Day (March 8th).
     * @returns Boolean indicating if it's International Women's Day.
     * @private
     */
    AchievementService.prototype.isInternationalWomensDay = function () {
        var now = new Date();
        return now.getMonth() === 2 && now.getDate() === 8;
    };
    /**
     * Checks if a random exercise contains a specific title.
     * @param title - The title to check for.
     * @param program - The Program object.
     * @returns Boolean indicating if the title is contained in the program's random exercise.
     * @private
     */
    AchievementService.prototype.randomExersizeContainsTitel = function (titel, program) {
        if (!program.isRandom) {
            return;
        }
        // Get the translated keyword for the current language since program titles are translated
        var translatedTitel = this.getTranslatedKeyword(titel);
        if (program.title.toLowerCase().includes(translatedTitel.toLowerCase())) {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * Gets the translated keyword based on current language.
     * @param keywordKey - The keyword key from ACHIEVEMENT_KEYWORDS.
     * @returns The translated keyword or the original if no translation exists.
     * @private
     */
    AchievementService.prototype.getTranslatedKeyword = function (keywordKey) {
        // Try to get current language from TranslateService first, fallback to LanguageService
        var currentLang = this.translateService.currentLang || this.languageService.getShortForm();
        var keywordTranslation = ACHIEVEMENT_KEYWORDS[keywordKey];
        if (keywordTranslation && keywordTranslation[currentLang]) {
            return keywordTranslation[currentLang];
        }
        // Return the original key if no translation is found
        return keywordKey;
    };
    /**
     * Checks if an exercise contains a specific title.
     * @param title - The title to check for.
     * @param program - The Program object.
     * @returns Boolean indicating if the title is contained in the program's exercise.
     * @private
     */
    AchievementService.prototype.exerciseContainsTitel = function (titel, program, currentExerciseIndex) {
        if (currentExerciseIndex === void 0) { currentExerciseIndex = 0; }
        var currentLang = this.languageService.getShortForm();
        var exercise = program.exercises[currentExerciseIndex];
        var exerciseTitle = exercise.title[currentLang] || exercise.title.de;
        // When in German, check for German keyword; when in English, check for English keyword
        var keywordToCheck;
        if (currentLang === 'de') {
            // In German mode, use the German keyword directly (no translation needed)
            keywordToCheck = titel; // Just use the German keyword as-is
        }
        else {
            // In English mode, use the English translation
            var keywordTranslation = ACHIEVEMENT_KEYWORDS[titel];
            keywordToCheck = keywordTranslation && keywordTranslation.en ? keywordTranslation.en : titel;
        }
        // Debug logging for achievement checking
        if (titel === 'Beine' || titel === 'Bein' || titel === 'Rücken' || titel === 'Schulter' || titel === 'Schultern') {
            console.log("[Achievement Debug] Checking \"" + titel + "\" in " + currentLang + ":", {
                originalKeyword: titel,
                keywordToCheck: keywordToCheck,
                exerciseTitle: exerciseTitle,
                currentLanguage: currentLang,
                titleEN: exercise.title.en || 'N/A',
                titleDE: exercise.title.de || 'N/A',
                willMatch: exerciseTitle.toLowerCase().includes(keywordToCheck.toLowerCase()),
            });
        }
        // Check if the keyword matches the exercise title
        if (exerciseTitle.toLowerCase().includes(keywordToCheck.toLowerCase())) {
            console.log("[Achievement Debug] \u2705 MATCH FOUND: \"" + exerciseTitle + "\" contains \"" + keywordToCheck + "\"");
            return true;
        }
        // Special handling for specific exercises in English with multiple variations
        if (currentLang === 'en') {
            var variations = [];
            // Leg exercises - check for both singular and plural
            if (titel === 'Beine' || titel === 'Bein') {
                variations = ['leg', 'legs', 'lower body', 'thigh', 'calf', 'calves'];
            }
            else if (titel === 'Schulter' || titel === 'Schultern') {
                variations = ['shoulder', 'shoulders', 'deltoid'];
            }
            else if (titel === 'Rücken') {
                variations = ['back', 'spine', 'upper back', 'lower back'];
            }
            for (var _i = 0, variations_1 = variations; _i < variations_1.length; _i++) {
                var variation = variations_1[_i];
                if (exerciseTitle.toLowerCase().includes(variation)) {
                    console.log("[Achievement Debug] Match found for " + titel + ": \"" + exerciseTitle + "\" contains \"" + variation + "\"");
                    return true;
                }
            }
        }
        // Fallback: If we're in English and no English title exists, check if German title matches German keyword
        if (currentLang === 'en' && (!exercise.title.en || exercise.title.en === '')) {
            var germanKeyword = ACHIEVEMENT_KEYWORDS[titel] ? ACHIEVEMENT_KEYWORDS[titel].de : titel;
            if (exercise.title.de && exercise.title.de.toLowerCase().includes(germanKeyword.toLowerCase())) {
                console.log("[Achievement Debug] Fallback match: German title \"" + exercise.title.de + "\" contains \"" + germanKeyword + "\"");
                return true;
            }
        }
        return false;
    };
    /**
     * Checks if an exercise contains a specific category.
     * @param category - The category to check for.
     * @param program - The Program object.
     * @returns Boolean indicating if the category is contained in the program's exercise.
     * @private
     */
    AchievementService.prototype.exerciseContainsCategory = function (category, program, currentExerciseIndex) {
        if (currentExerciseIndex === void 0) { currentExerciseIndex = 0; }
        var result = program.exercises[currentExerciseIndex].categories.find(function (element) {
            return element.title.internal.includes(category);
        });
        if (result) {
            return true;
        }
        return false;
    };
    /**
     * Checks if an exercise is related to back muscle groups.
     * @param program - The Program object.
     * @returns Boolean indicating if the exercise is related to the back.
     * @private
     */
    AchievementService.prototype.isBackExercise = function (program, currentExerciseIndex) {
        return (this.exerciseContainsTitel('Rücken', program, currentExerciseIndex) ||
            this.exerciseContainsTitel('Oberkörper', program, currentExerciseIndex) ||
            this.exerciseContainsTitel('Wirbelsäule', program, currentExerciseIndex) ||
            this.exerciseContainsTitel('Becken', program, currentExerciseIndex) ||
            this.exerciseContainsTitel('Halswirbelsäule', program, currentExerciseIndex));
    };
    /**
     * Checks if an exercise is related to leg muscle groups.
     * @param program - The Program object.
     * @returns Boolean indicating if the exercise is related to the legs.
     * @private
     */
    AchievementService.prototype.isLegExercise = function (program, currentExerciseIndex) {
        return (this.exerciseContainsTitel('Beine', program, currentExerciseIndex) ||
            this.exerciseContainsTitel('Bein', program, currentExerciseIndex) ||
            this.exerciseContainsTitel('Hüftbeuger', program, currentExerciseIndex) ||
            this.exerciseContainsTitel('Waden', program, currentExerciseIndex) ||
            this.exerciseContainsTitel('Oberschenkel', program, currentExerciseIndex));
    };
    /**
     * Checks if specific exercise categories were done on the same day.
     * @param categories - Array of categories to check.
     * @param stats - User statistics.
     * @param program - The Program object.
     * @returns A promise that resolves with an array of unlocked Achievement objects.
     * @private
     */
    AchievementService.prototype.checkExerciseCategoriesDoneOnSameDay = function (categories, _stats, _userAchievementData, program, currentExerciseIndex) {
        return __awaiter(this, void 0, void 0, function () {
            var unlockedAchievements, _i, categories_1, category, _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        unlockedAchievements = [];
                        _i = 0, categories_1 = categories;
                        _e.label = 1;
                    case 1:
                        if (!(_i < categories_1.length)) return [3 /*break*/, 6];
                        category = categories_1[_i];
                        if (!this.exerciseContainsCategory(category, program, currentExerciseIndex)) return [3 /*break*/, 5];
                        if (!(category === 'Augen')) return [3 /*break*/, 3];
                        _b = (_a = unlockedAchievements).push;
                        return [4 /*yield*/, this.updateAchievementForUser('Sehkraft')];
                    case 2:
                        _b.apply(_a, [_e.sent()]);
                        _e.label = 3;
                    case 3:
                        if (!(category === 'Achtsamkeit')) return [3 /*break*/, 5];
                        _d = (_c = unlockedAchievements).push;
                        return [4 /*yield*/, this.updateAchievementForUser('Achtsamkeit')];
                    case 4:
                        _d.apply(_c, [_e.sent()]);
                        _e.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6: return [2 /*return*/, unlockedAchievements];
                }
            });
        });
    };
    /**
     * Checks if a specific achievement was updated today.
     * @param name - The name of the achievement to check.
     * @param achievements - The array of achievements to search.
     * @returns Boolean indicating if the achievement was updated today.
     * @private
     */
    AchievementService.prototype.checkAchievementUpdatedToday = function (name, achievements) {
        var today = new Date();
        var matchingAchievement = achievements.find(function (achievement) { return achievement.name === name; });
        if (!matchingAchievement) {
            // No achievement with this name was found
            return false;
        }
        // Check if the achievement was updated today
        var updatedAt = new Date(matchingAchievement.updatedAt[matchingAchievement.updatedAt.length - 1]);
        return updatedAt.toDateString() === today.toDateString();
    };
    /**
     * Checks if all exercises are done based on statistics and exercise size.
     * @param data - User statistics data.
     * @param allExerciseSize - Total number of exercises.
     * @returns Boolean indicating if all exercises are completed.
     * @private
     */
    AchievementService.prototype.checkIfAllExercisesDone = function (data, allExerciseSize) {
        var exerciseNames = data.map(function (obj) {
            return obj.exerciseTitle;
        });
        var uniqueCount = new Set(exerciseNames).size;
        if (allExerciseSize === uniqueCount) {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * checks if a user has completed exercises on at least X different days.
     * @param data - User statistics data containing exercise history.
     * @param days - Number of unique days required (5 for Rookie achievement).
     * @returns A promise that resolves to a boolean indicating if the condition is met.
     */
    AchievementService.prototype.checkExerciseCountDays = function (data, days) {
        return __awaiter(this, void 0, void 0, function () {
            var ach, startDate, filteredData, datesArray, uniqueDays, uniqueDayCount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSingleAchievement('Meilenstein')];
                    case 1:
                        ach = _a.sent();
                        startDate = new Date(ach.createdAt);
                        console.log("Checking for " + days + " days with exercises since " + startDate.toISOString());
                        filteredData = data.filter(function (obj) {
                            var exerciseDate = new Date(obj.timeStamp);
                            return exerciseDate >= startDate;
                        });
                        datesArray = filteredData.map(function (item) {
                            var date = new Date(item.timeStamp);
                            return date.toISOString().split('T')[0]; // Format: YYYY-MM-DD
                        });
                        uniqueDays = new Set(datesArray);
                        uniqueDayCount = uniqueDays.size;
                        console.log("Found " + uniqueDayCount + " unique days with exercises");
                        console.log("Unique days: " + Array.from(uniqueDays).join(', '));
                        // Check if the required number of days is reached
                        return [2 /*return*/, uniqueDayCount >= days];
                }
            });
        });
    };
    /**
     * Logic for the B2Action Hero Achievement.
     * Checks if user completed 4 exercises per day for 5 consecutive days.
     * Only counts streaks that haven't been awarded yet (after the last award date).
     * @param data - An array of IFilteredStats objects.
     * @param userAchievementData - Optional: existing achievements to check last award date
     * @returns True if the user has a NEW 5 consecutive days with 4+ exercises each.
     */
    AchievementService.prototype.checkB2ActionHero = function (data, userAchievementData) {
        return __awaiter(this, void 0, void 0, function () {
            var ach, startDate, REQUIRED_DAYS, REQUIRED_EXERCISES_PER_DAY, lastAwardDate, b2aHero, b2aHero, error_3, exerciseCountByDate, today, todayKey, todayExercises, sortedDates, consecutiveStreak, daysRemaining, exercisesNeededToday;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSingleAchievement('Meilenstein')];
                    case 1:
                        ach = _a.sent();
                        startDate = new Date(ach.createdAt);
                        REQUIRED_DAYS = 5;
                        REQUIRED_EXERCISES_PER_DAY = 4;
                        console.log('🎯 B2Action Hero Check - Starting analysis...');
                        console.log("   Required: " + REQUIRED_DAYS + " consecutive days with " + REQUIRED_EXERCISES_PER_DAY + "+ exercises each");
                        lastAwardDate = null;
                        if (!userAchievementData) return [3 /*break*/, 2];
                        b2aHero = userAchievementData.find(function (a) { return a.name === 'B2Action Hero'; });
                        if (b2aHero && b2aHero.updatedAt && b2aHero.updatedAt.length > 0) {
                            lastAwardDate = new Date(b2aHero.updatedAt[b2aHero.updatedAt.length - 1]);
                            console.log("   Last B2Action Hero award: " + lastAwardDate.toISOString().split('T')[0]);
                        }
                        return [3 /*break*/, 5];
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.getSingleAchievement('B2Action Hero')];
                    case 3:
                        b2aHero = _a.sent();
                        if (b2aHero && b2aHero.updatedAt && b2aHero.updatedAt.length > 0) {
                            lastAwardDate = new Date(b2aHero.updatedAt[b2aHero.updatedAt.length - 1]);
                            console.log("   Last B2Action Hero award: " + lastAwardDate.toISOString().split('T')[0]);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        error_3 = _a.sent();
                        console.log('   No previous B2Action Hero awards found');
                        return [3 /*break*/, 5];
                    case 5:
                        exerciseCountByDate = this.countExercisesByDate(data, startDate);
                        today = new Date();
                        todayKey = today.getFullYear() + "-" + ('0' + (today.getMonth() + 1)).slice(-2) + "-" + ('0' + today.getDate()).slice(-2);
                        todayExercises = exerciseCountByDate.get(todayKey) || 0;
                        console.log("   Today (" + todayKey + "): " + todayExercises + " exercises completed");
                        sortedDates = this.getSortedDatesFromMap(exerciseCountByDate);
                        if (sortedDates.length === 0) {
                            console.log('   ❌ No exercise data found');
                            return [2 /*return*/, false];
                        }
                        consecutiveStreak = this.findNewConsecutiveDaysWithExercises(sortedDates, exerciseCountByDate, REQUIRED_EXERCISES_PER_DAY, REQUIRED_DAYS, lastAwardDate);
                        if (consecutiveStreak.isComplete) {
                            console.log("   \u2705 B2Action Hero ACHIEVED! Found NEW " + REQUIRED_DAYS + " consecutive days with " + REQUIRED_EXERCISES_PER_DAY + "+ exercises!");
                            console.log("   \uD83C\uDFC6 New streak dates: " + consecutiveStreak.streakDates.join(' → '));
                            return [2 /*return*/, true];
                        }
                        else {
                            daysRemaining = REQUIRED_DAYS - consecutiveStreak.currentLength;
                            console.log("   \uD83D\uDCCA Current streak progress: " + consecutiveStreak.currentLength + "/" + REQUIRED_DAYS + " consecutive days");
                            if (consecutiveStreak.currentLength > 0) {
                                console.log("   \uD83D\uDCC5 Current streak dates: " + consecutiveStreak.streakDates.join(' → '));
                            }
                            console.log("   \uD83D\uDCC5 Days remaining: " + daysRemaining + " more day(s) needed for next achievement");
                            // Additional helpful info
                            if (todayExercises < REQUIRED_EXERCISES_PER_DAY) {
                                exercisesNeededToday = REQUIRED_EXERCISES_PER_DAY - todayExercises;
                                console.log("   \uD83D\uDCAA Today's progress: Need " + exercisesNeededToday + " more exercise(s) today to maintain/start streak");
                            }
                            else {
                                console.log("   \u2705 Today's requirement met! Keep going for " + daysRemaining + " more day(s)");
                            }
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    /**
     * Helper: Count exercises by date
     */
    AchievementService.prototype.countExercisesByDate = function (data, startDate) {
        var exercisesByDate = new Map();
        data.forEach(function (stat) {
            var date = new Date(stat.timeStamp);
            if (date >= startDate) {
                // Use local date string format to ensure consistent date grouping
                var year = date.getFullYear();
                var month = ('0' + (date.getMonth() + 1)).slice(-2);
                var day = ('0' + date.getDate()).slice(-2);
                var dateKey = year + "-" + month + "-" + day;
                exercisesByDate.set(dateKey, (exercisesByDate.get(dateKey) || 0) + 1);
            }
        });
        return exercisesByDate;
    };
    /**
     * Helper: Get sorted date strings from exercise map
     */
    AchievementService.prototype.getSortedDatesFromMap = function (exercisesByDate) {
        return Array.from(exercisesByDate.keys()).sort(function (a, b) {
            return new Date(a).getTime() - new Date(b).getTime();
        });
    };
    /**
     * Helper: Find NEW consecutive days with required exercises after last award date
     * @returns Object with information about the current streak
     */
    AchievementService.prototype.findNewConsecutiveDaysWithExercises = function (sortedDates, exercisesByDate, requiredExercises, targetDays, lastAwardDate) {
        var currentConsecutive = 0;
        var lastDate = null;
        var currentStreak = [];
        var bestNewStreak = [];
        var bestNewStreakLength = 0;
        console.log('   📋 Analyzing exercise history for NEW streak:');
        if (lastAwardDate) {
            console.log("   \uD83D\uDD0D Only counting streaks after last award: " + lastAwardDate.toISOString().split('T')[0]);
        }
        for (var _i = 0, sortedDates_1 = sortedDates; _i < sortedDates_1.length; _i++) {
            var dateStr = sortedDates_1[_i];
            var currentDate = new Date(dateStr);
            // Skip dates before or on the last award date
            if (lastAwardDate && currentDate <= lastAwardDate) {
                console.log("      " + dateStr + ": Skipped (before/on last award date)");
                continue;
            }
            var exerciseCount = exercisesByDate.get(dateStr) || 0;
            var hasEnoughExercises = exerciseCount >= requiredExercises;
            console.log("      " + dateStr + ": " + exerciseCount + " exercises " + (hasEnoughExercises ? '✅' : '❌') + " (need " + requiredExercises + "+)");
            if (hasEnoughExercises) {
                if (lastDate === null) {
                    // First day with enough exercises after award
                    currentConsecutive = 1;
                    currentStreak = [dateStr];
                }
                else if (this.isConsecutiveDay(lastDate, currentDate)) {
                    // Consecutive day with enough exercises
                    currentConsecutive++;
                    currentStreak.push(dateStr);
                }
                else {
                    // Gap in dates, save current streak if it's the best and restart
                    if (currentStreak.length > bestNewStreakLength) {
                        bestNewStreak = currentStreak.slice();
                        bestNewStreakLength = currentStreak.length;
                    }
                    if (currentStreak.length > 0) {
                        console.log("      \uD83D\uDD04 Streak broken! Previous streak: " + currentStreak.length + " days");
                    }
                    currentConsecutive = 1;
                    currentStreak = [dateStr];
                }
                lastDate = currentDate;
                // Check if we have a complete new streak
                if (currentConsecutive >= targetDays) {
                    console.log("   \uD83C\uDFC6 New complete streak found: " + currentStreak.join(' → '));
                    return {
                        isComplete: true,
                        currentLength: currentConsecutive,
                        streakDates: currentStreak.slice(0, targetDays) // Return only the required days
                    };
                }
            }
            else {
                // Not enough exercises on this day, save current streak if it's the best and break
                if (currentStreak.length > bestNewStreakLength) {
                    bestNewStreak = currentStreak.slice();
                    bestNewStreakLength = currentStreak.length;
                }
                if (currentStreak.length > 0) {
                    console.log("      \u26A0\uFE0F Streak broken! Only " + exerciseCount + " exercises (need " + requiredExercises + "+). Previous streak: " + currentStreak.length + " days");
                }
                currentConsecutive = 0;
                lastDate = null;
                currentStreak = [];
            }
        }
        // Check the final streak
        if (currentStreak.length > bestNewStreakLength) {
            bestNewStreak = currentStreak.slice();
            bestNewStreakLength = currentStreak.length;
        }
        if (bestNewStreak.length > 0) {
            console.log("   \uD83D\uDCC8 Current best NEW streak: " + bestNewStreak.join(' → ') + " (" + bestNewStreak.length + " days)");
        }
        return {
            isComplete: false,
            currentLength: bestNewStreakLength,
            streakDates: bestNewStreak
        };
    };
    /**
     * Helper: Check if two dates are consecutive days
     */
    AchievementService.prototype.isConsecutiveDay = function (date1, date2) {
        var diffTime = date2.getTime() - date1.getTime();
        var diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));
        return diffDays === 1;
    };
    /**
     * Divides an array into smaller chunks.
     * @param arr - The array to be divided.
     * @param size - The size of each chunk.
     * @returns An array of Achievement array chunks.
     * @public
     */
    AchievementService.prototype.chunkArray = function (arr, size) {
        var chunks = [];
        for (var i = 0; i < arr.length; i += size) {
            chunks.push(arr.slice(i, i + size));
        }
        return chunks;
    };
    return AchievementService;
}());
export { AchievementService };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/services/achievement.service.ts.pre-build-optimizer.js